export const maxNoteLength = 140;
